import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import moment from 'moment';

import { CompactCard } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import { HRAdvancePaymentsRequest } from '../../requests/dashboards';
import AdvancePaymentDataTable from '../Shared/AdvancePayment/AdvancePaymentDataTable';
import columns from '../Shared/AdvancePayment/approveColumns';

const AdvancePaymentIndex = ({ moreData, setMoreData, todayMoment = null, twoMonthsAgo = null }) => {
  const [cards, setCards] = useState({});
  const [customParams, setCustomParams] = useState({});
  const [activeCard, setActiveCard] = useState('all');
  const [defaultStartDate, setDefaultStartDate] = useState(twoMonthsAgo);
  const [defaultEndDate, setDefaultEndDate] = useState(todayMoment);
  const dispatch = useDispatch();

  const fetchDashboardCards = () => {
    const request = async () => {
      HRAdvancePaymentsRequest({
        dispatch,
        successCallback: response => setCards(camelCaseEmptyStringRecursive(response.data))
      });
    };
    request();
  };

  const handleClick = card => {
    switch (card) {
      case 'pending':
        setCustomParams({ status: 'pending' });
        setActiveCard('pending');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      case 'year':
        setCustomParams({ status: 'approved' });
        setActiveCard('year');
        setDefaultStartDate(moment().startOf('year'));
        setDefaultEndDate(moment().endOf('year'));
        break;
      case 'rejected':
        setCustomParams({ status: 'rejected' });
        setActiveCard('rejected');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
      case 'month':
        setCustomParams({ status: 'approved' });
        setActiveCard('month');
        setDefaultStartDate(moment().startOf('month'));
        setDefaultEndDate(moment().endOf('month'));
        break;
      default:
        setCustomParams({});
        setActiveCard('all');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(!moreData);
        break;
    }
  };

  useEffect(fetchDashboardCards, [moreData]);

  return (
    <>
      <Row className="m-top mb-2">
        <Col md={3} xs={12}>
          <CompactCard
            variant="info-grey"
            title={cards.all}
            subtitle="Anticipos Solicitados"
            label="Solicitados"
            active={activeCard === 'all'}
            onClick={() => handleClick('all')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="warning"
            title={cards.pending}
            subtitle="Anticipos por Autorizar"
            label="Por Autorizar"
            active={activeCard === 'pending'}
            onClick={() => handleClick('pending')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="danger"
            title={cards.rejected}
            subtitle="Anticipos Rechazados"
            label="Rechazados"
            active={activeCard === 'rejected'}
            onClick={() => handleClick('rejected')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="primary"
            title={cards.amountThisYear}
            subtitle="En Anticipos Aprobados"
            label="Aprobados en el Año"
            active={activeCard === 'year'}
            onClick={() => handleClick('year')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="primary"
            title={cards.amountThisMonth}
            subtitle="En Anticipos Aprobados"
            label="Aprobados en el Mes"
            active={activeCard === 'month'}
            onClick={() => handleClick('month')}
          />
        </Col>
      </Row>
      <AdvancePaymentDataTable
        columns={columns}
        customParams={customParams}
        defaultStartDate={defaultStartDate}
        defaultEndDate={defaultEndDate}
        moreData={moreData}
        setMoreData={setMoreData}
        withImport
      />
    </>
  );
};

export default AdvancePaymentIndex;
